(function () {
  function initCarousel(c) {
    if (c.dataset.picCarouselReady) return;
    c.dataset.picCarouselReady = '1';
    var track = c.querySelector('.pic-carousel__track');
    var prev = c.querySelector('.pic-carousel__nav--prev');
    var next = c.querySelector('.pic-carousel__nav--next');
    if (!track || !prev || !next) return;

    function step() {
      var firstCard = track.querySelector('.pic-card');
      if (firstCard) return firstCard.getBoundingClientRect().width + 12;
      return track.clientWidth * 0.6;
    }

    function updateButtons() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
      if (track.scrollWidth <= track.clientWidth + 4) {
        prev.style.display = 'none';
        next.style.display = 'none';
      } else {
        prev.style.display = '';
        next.style.display = '';
      }
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('.pic-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init when sections are reloaded in theme editor
  document.addEventListener('shopify:section:load', initAll);
})();
